import script from "./PanelTester.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelTester.vue?vue&type=script&setup=true&lang=js"

import "./PanelTester.vue?vue&type=style&index=0&id=3bb6562d&lang=css"

const __exports__ = script;

export default __exports__